import { Box } from '@mui/material';
import { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router';
import queryString from 'query-string';
import { NON_EU_COUNTRY_IMPORT_REPORT_TYPE, SALES_REPORTS } from 'redux/reducers/reports/constants';
import { downloadSalesReportRequest, getSalesReportsRequest } from 'redux/reducers/reports/reducer';
import {
	getDownloadSalesReportsLoader,
	getSalesReports,
	getSalesReportsLoader,
} from 'redux/reducers/reports/selectors';
import { TGetSalesReportsResponseRowsItem, TSalesReportTypes } from 'redux/reducers/reports/types';
import { PAGE_SIZE } from 'services/constants/env';
import { EasTableWithoutFilter } from 'ui/EasTableWithoutFilter';
import { ReportsDescription } from 'components/ReportsDescription';
import { tableStructure } from './tableStructure';

export const DomesticReports: FC = () => {
	const params = useParams<{ typeOfReport?: string }>();
	const { typeOfReport } = params;
	const { search } = useLocation();
	const { page } = queryString.parse(search);

	const salesReports = SALES_REPORTS.find((item) => item.path === typeOfReport);
	const salesReportsType = salesReports?.type as TSalesReportTypes;

	const dispatch = useDispatch();
	const reports = useSelector(getSalesReports);
	const reportsIsLoading = useSelector(getSalesReportsLoader);
	const downloadReportLoader = useSelector(getDownloadSalesReportsLoader);

	useEffect(() => {
		dispatch(
			getSalesReportsRequest({
				reportsType: salesReportsType,
				pageNumber: page ? +page : 1,
				pageSize: PAGE_SIZE,
			}),
		);
	}, [dispatch, salesReportsType, page]);

	const handleAction = (id: number) => {
		const report = reports?.data?.find((item) => item.id === id);
		if (!report) return;

		dispatch(
			downloadSalesReportRequest({
				reportId: report.id,
				format: 'csv',
			}),
		);
	};

	return (
		<Box sx={{ padding: '0px 10px 16px 10px' }}>
			{!reportsIsLoading && !!reports?.data?.length && !!salesReports?.description && (
				<ReportsDescription description={salesReports?.description} />
			)}
			<EasTableWithoutFilter<TGetSalesReportsResponseRowsItem>
				tableStructure={tableStructure}
				items={reports}
				itemsIsLoading={reportsIsLoading || downloadReportLoader}
				handleAction={handleAction}
			/>
		</Box>
	);
};
